/**
 * 是否忽略鉴权错误
 */
export const IGNORE_AUTH_ERROR: unique symbol = Symbol('IGNORE_AUTH_ERROR');
